import { render, staticRenderFns } from "./bigBagMsg.vue?vue&type=template&id=55d85e1c&scoped=true"
import script from "./bigBagMsg.vue?vue&type=script&lang=js"
export * from "./bigBagMsg.vue?vue&type=script&lang=js"
import style0 from "./bigBagMsg.vue?vue&type=style&index=0&id=55d85e1c&prod&lang=scss"
import style1 from "./bigBagMsg.vue?vue&type=style&index=1&id=55d85e1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d85e1c",
  null
  
)

export default component.exports